import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, X } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface SymptomsListProps {
  symptoms: string[];
  onChange: (symptoms: string[]) => void;
}

export function SymptomsList({ symptoms, onChange }: SymptomsListProps) {
  const [newSymptom, setNewSymptom] = useState('');

  const handleAdd = () => {
    if (newSymptom.trim()) {
      onChange([...symptoms, newSymptom.trim()]);
      setNewSymptom('');
    }
  };

  const handleRemove = (index: number) => {
    onChange(symptoms.filter((_, i) => i !== index));
  };

  return (
    <Card className="border-0 shadow-md">
      <CardHeader className="border-b">
        <CardTitle>Symptoms</CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="space-y-4">
          <div className="flex gap-2">
            <Input
              value={newSymptom}
              onChange={(e) => setNewSymptom(e.target.value)}
              placeholder="Enter a symptom"
              onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
            />
            <Button onClick={handleAdd}>
              <Plus className="h-4 w-4" />
              Add
            </Button>
          </div>

          <div className="flex flex-wrap gap-2">
            {symptoms.map((symptom, index) => (
              <Badge
                key={index}
                variant="secondary"
                className="flex items-center gap-1"
              >
                {symptom}
                <button
                  onClick={() => handleRemove(index)}
                  className="ml-1 hover:text-destructive"
                >
                  <X className="h-3 w-3" />
                </button>
              </Badge>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
